<main class="controle-page">
  <header class="page-header">
    <div>
      <h1>Controle Integrações</h1>
      <p>Acompanhamento das execuções e retornos do Service Layer.</p>
    </div>
    <button type="button" class="btn btn-outline-secondary" title="Atualizar dados" (click)="filtrar()">
      <i class="fa fa-refresh" aria-hidden="true"></i>
      <span>Atualizar</span>
    </button>
  </header>

  <section class="filters" aria-label="Filtros do relatório">
    <label>
      Data inicial
      <input type="date" class="form-control" [(ngModel)]="filtro.data_inicio">
    </label>
    <label>
      Data final
      <input type="date" class="form-control" [(ngModel)]="filtro.data_fim">
    </label>
    <label>
      Nome
      <input type="text" class="form-control" placeholder="Ex.: SapB1Clientes" [(ngModel)]="filtro.chamada_nome" (keyup.enter)="filtrar()">
    </label>
    <label>
      Status
      <select class="form-control" [(ngModel)]="filtro.status">
        <option value="">Todos</option>
        <option value="SUCESSO">Sucesso - 200</option>
        <option value="ERRO">Erros</option>
      </select>
    </label>
    <div class="filter-actions">
      <button type="button" class="btn btn-secondary" (click)="limpar()">Limpar</button>
      <button type="button" class="btn btn-primary" (click)="filtrar()">Filtrar</button>
    </div>
  </section>

  <div *ngIf="carregando" class="loading-state">
    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
    Carregando integrações...
  </div>

  <ng-container *ngIf="!carregando">
    <section class="metrics" aria-label="Resumo das integrações">
      <article class="metric metric-neutral">
        <span>Execuções</span>
        <strong>{{ totalExecucoes }}</strong>
        <small>{{ totalChamadas }} chamadas SL</small>
      </article>
      <article class="metric metric-success">
        <span>Sucesso</span>
        <strong>{{ totalSucessos }}</strong>
        <small>{{ taxaSucesso | number:'1.1-1' }}% das execuções</small>
      </article>
      <article class="metric metric-error">
        <span>Erros</span>
        <strong>{{ totalErros }}</strong>
        <small>Requerem atenção</small>
      </article>
      <article class="metric metric-time">
        <span>Tempo médio</span>
        <strong>{{ formatarDuracao(tempoMedio) }}</strong>
        <small>{{ totalItens | number:'1.0-0' }} itens processados</small>
      </article>
    </section>

    <section class="summary-panel" *ngIf="resumoIntegracoes.length">
      <div class="section-heading">
        <div>
          <h2>Desempenho por integração</h2>
          <p>Volume, disponibilidade e duração média no período.</p>
        </div>
      </div>
      <div class="integration-list">
        <div class="integration-row" *ngFor="let item of resumoIntegracoes">
          <div class="integration-name">
            <strong>{{ item.nome }}</strong>
            <span>{{ item.execucoes }} execução(ões) · {{ formatarDuracao(item.tempoMedio) }}</span>
          </div>
          <div class="availability" title="Taxa de sucesso">
            <div class="availability-track">
              <span [style.width.%]="item.percentual"></span>
            </div>
            <strong>{{ item.percentual | number:'1.1-1' }}%</strong>
          </div>
          <div class="integration-counts">
            <span class="success-text">{{ item.sucessos }} sucesso</span>
            <span class="error-text">{{ item.erros }} erro</span>
          </div>
        </div>
      </div>
    </section>

    <section class="report-panel">
      <div class="section-heading">
        <div>
          <h2>Relatório detalhado</h2>
          <p>{{ registros.length }} registro(s) encontrado(s).</p>
        </div>
      </div>

      <div class="empty-state" *ngIf="!registros.length">
        Nenhuma execução encontrada para os filtros informados.
      </div>

      <div class="table-responsive" *ngIf="registros.length">
        <table class="table integration-table">
          <thead>
            <tr>
              <th aria-label="Detalhes"></th>
              <th>Id</th>
              <th>Nome</th>
              <th>Dt. Hr. inicial</th>
              <th>Dt. Hr. final</th>
              <th>Tempo execução</th>
              <th class="text-center">Chamadas SL</th>
              <th class="text-center">Itens</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of registros">
              <td>
                <button type="button" class="info-button" title="Ver log da execução" (click)="abrirLog(item)">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </button>
              </td>
              <td>{{ item.id }}</td>
              <td><strong>{{ item.chamada_nome || '-' }}</strong></td>
              <td>{{ formatarDataHora(item.hr_inicial) }}</td>
              <td>{{ formatarDataHora(item.hr_final) }}</td>
              <td>{{ formatarDuracao(item.tempo_execucao_ms) }}</td>
              <td class="text-center">{{ item.chamadas_servicelayer }}</td>
              <td class="text-center">{{ item.totalitens }}</td>
              <td><span class="status-tag" [class.status-success]="item.sucesso" [class.status-error]="!item.sucesso">{{ item.status || 'Sem status' }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </ng-container>
</main>

<div class="modal-backdrop-custom" *ngIf="logSelecionado" (click)="fecharLog()">
  <section class="log-modal" role="dialog" aria-modal="true" aria-labelledby="log-title" (click)="$event.stopPropagation()">
    <header>
      <div>
        <span>Execução #{{ logSelecionado.id }}</span>
        <h2 id="log-title">{{ logSelecionado.chamada_nome }}</h2>
      </div>
      <button type="button" class="close-button" title="Fechar" (click)="fecharLog()">&times;</button>
    </header>
    <div class="log-meta">
      <span>{{ formatarDataHora(logSelecionado.hr_inicial) }}</span>
      <span class="status-tag" [class.status-success]="logSelecionado.sucesso" [class.status-error]="!logSelecionado.sucesso">{{ logSelecionado.status || 'Sem status' }}</span>
    </div>
    <pre>{{ formatarLog(logSelecionado.log_status) }}</pre>
    <footer><button type="button" class="btn btn-secondary" (click)="fecharLog()">Fechar</button></footer>
  </section>
</div>
